document.addEventListener("DOMContentLoaded", function () {
    const siteHeader = document.getElementById('SiteHeader');
    const sectionHero = document.getElementById('sectionHero');
    if (siteHeader && sectionHero) {
        const headerHeight = siteHeader.offsetHeight;
        sectionHero.style.paddingTop = `${headerHeight}px`;
    }

    const productVideoOverlay = document.getElementById('productVideoOverlay');
    const productVideoModal = document.getElementById('productVideoModal');
    const productHTMVideoModal = document.getElementById('productHTMVideoModal');

    // Add null checks for video modal elements
    if (productVideoOverlay) {
        productVideoOverlay.onclick = () => {
            productVideoModal.classList.remove("show");
            productHTMVideoModal.classList.remove("show");
            productVideoOverlay.classList.remove("open");
        }
    }

    // Add timeout to prevent infinite interval
    let intervalCount = 0;
    const maxIntervalAttempts = 30; // Stop after 30 seconds

    const interval = setInterval(() => {
        intervalCount++;

        // Stop interval after max attempts to prevent infinite running
        if (intervalCount >= maxIntervalAttempts) {
            console.warn('Interval stopped: best-fit-size-chart element not found after 30 seconds');
            clearInterval(interval);
            return;
        }

        const target = document.querySelector('.best-fit-size-chart');

        if (target) {
            const existingBtn = target.querySelector('.scr-open-size-chart');
            const hasNewBtn = target.querySelector('.btn-video');

            if (existingBtn && document.body.classList.contains('template-apparel')) {
                existingBtn.textContent = 'Size Chart';
            }

            // Proceed only if existing button is already there and new one isn't
            if (existingBtn && !hasNewBtn) {
                const newButton = document.createElement('button');
                newButton.className = 'btn-video btn-video-popup';
                if (document.body.classList.contains('template-apparel')) {
                    newButton.textContent = 'Model Video';
                } else {
                    newButton.textContent = 'Look Inside';
                }

                const htmButton = document.createElement('button');
                htmButton.className = 'btn-video btn-htm-popup';
                htmButton.textContent = "How It's Made";

                // Create FAQ link
                const faqSection = document.querySelector('[id^="shopify-section"][id*="faq"]');
                const newFAQ = document.createElement('a');
                newFAQ.className = 'btn-faq';
                newFAQ.textContent = 'FAQ';
                if (faqSection) {
                    newFAQ.href = `#${faqSection.id}`;
                }

                newButton.addEventListener('click', () => {
                    const videoModal = document.getElementById('productVideoModal');
                    const videoOverlay = document.getElementById('productVideoOverlay');
                    if (videoModal && videoOverlay) {
                        videoModal.classList.add('show');
                        videoOverlay.classList.add('open');
                    }
                });

                htmButton.addEventListener('click', () => {
                    const videoModal = document.getElementById('productHTMVideoModal');
                    const videoOverlay = document.getElementById('productVideoOverlay');
                    if (videoModal && videoOverlay) {
                        videoModal.classList.add('show');
                        videoOverlay.classList.add('open');
                    }
                });

                // Append without removing anything
                target.appendChild(newButton);
                target.appendChild(htmButton);
                // target.appendChild(newFAQ);

                // Clear interval immediately after successful addition
                clearInterval(interval);
            }

            // Also clear if both buttons already exist
            else if (hasExistingBtn && hasNewBtn) {
                clearInterval(interval);
            }
        }
    }, 1000);

    document.querySelectorAll('.btn-theme-customize-now').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const swatchButton = document.querySelector('.cl-po--swatch-button');
            if (swatchButton) swatchButton.click();
        });
    });

    // Sticky functionality shared across promotion and sticky ATC sections
    function initStickySection(sectionSelector) {
        const section = document.querySelector(sectionSelector);
        const footer = document.querySelector('[id*="text_with_icons"]');

        if (!section) {
            return;
        }

        let isSticky = false;
        let originalPosition = section.offsetTop;
        const stickyClass = 'show';

        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const sectionHeight = section.offsetHeight;
            let footerTop = null;
            if (footer) {
                const footerRect = footer.getBoundingClientRect();
                footerTop = footerRect.top + window.pageYOffset;
            }

            if (
                scrollTop > originalPosition &&
                (!footerTop || scrollTop + sectionHeight < footerTop)
            ) {
                if (!isSticky) {
                    section.classList.add(stickyClass);
                    isSticky = true;
                }
            } else if (isSticky) {
                section.classList.remove(stickyClass);
                isSticky = false;
            }
        }

        function handleResize() {
            originalPosition = section.offsetTop;
            handleScroll();
        }

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        handleScroll();
    }

    // Initialize sticky behavior for promotion and sticky ATC sections when DOM is ready
    initStickySection('[id*="shopdev_promotion"]');
    initStickySection('.section-sticky-atc');

    const btnHowItsMade = document.querySelector('.btn-video-popup');
    if (btnHowItsMade) {
        btnHowItsMade.addEventListener('click', function(e) {
            e.preventDefault();

            const htmModal = document.getElementById('productHTMVideoModal');
            const videoOverlay = document.getElementById('productVideoOverlay');

            if (htmModal && videoOverlay) {
                htmModal.classList.add('show');
                videoOverlay.classList.add('open');
            }
        });
    }
});
